import actions from "./actions";

export default {
  namespaced: true,
  state: {
    deposits: [],
    dataLoading: true
  },

  getters: {
    deposits: state => {
      return state.deposits;
    },

    dataLoading: state => {
      return state.dataLoading;
    }
  },
  mutations: {
    setDeposits(state, deposit) {
      state.deposits = deposit;
    },

    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    }
  },

  actions
};